export const PRODUCT_NAME = {
  IMPACT_TRACKER: 'ImpactTracker',
  TRACK_IMPACT: 'TrackImpact',
  IMPACT_ACADEMY: 'ImpactAcademy'
};
